import React, { useContext, useEffect, useState } from 'react';
import { IConfig } from './config/interfaces';
import { Context } from './context/context';
import Modal from './components/Modal';
import './stylesheets/index.css';
import Logo from './assets/images/cb-black.jpg';
import axios from 'axios';
import PaymentInput from './components/PaymentForm';
import GoogleMapsScript from './hooks/useGoogleMap';
import { Toaster } from 'sonner';
import { buildWidgetAnalyticsContext, postParentAnalyticsEvent } from './analytics/widgetTracking';

const App: React.FC = (props) => {
	const [config] = useState<IConfig>(JSON.parse(useContext(Context)));

	axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

	axios.interceptors.request.use(
		(request) => {
			if (config.publicKey) {
				request.headers.apiKey = `${config.publicKey}`;
			}
			return request;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	axios.interceptors.response.use(
		(response) => {
			return response;
		},
		(error) => {
			if (error?.response?.status == 401) {
				// throw new Error("You're not authorized");
			}
			return Promise.reject(error);
		}
	);

	useEffect(() => {
		postParentAnalyticsEvent('cobuyr_widget_loaded', buildWidgetAnalyticsContext(config));
	}, [config]);

	return (
		<>
			<Modal>
				<PaymentInput />
			</Modal>

			<GoogleMapsScript />
			<Toaster position="top-center" richColors />
			<div className="flex justify-center items-end h-screen md:pb-2 pb-4">
				<div>
					<p className="text-sm text-black font-semibold text-center ml-2">Powered by</p>
					<img src={Logo} className="w-28 h-12" />
				</div>
			</div>
		</>
	);
};

export default App;
